import { useState } from "react";
import { createActivityAsync, updateActivityAsync, assignActivityKpiAsync, removeActivityKpiAsync, enableActivityAsync, disableActivityAsync } from "@features/admin/activity/services/activitySvc";
import { CreateActivityRequest, UpdateActivityRequest } from "@features/admin/activity/types/activityRequests";
import { useApiError } from "@infrastructure/api/hooks/useApiError";

export function useActivityAction() {
    const [busy, setBusy] = useState(false);
    const _showError = useApiError();

    const doActivityCreate = async (nationId: number, data: CreateActivityRequest) => {
        setBusy(true);

        const response = await createActivityAsync(nationId, data);
        setBusy(false);
        return response;

    };

    const doActivityUpdate = async (nationId: number, activityId: number, data: UpdateActivityRequest) => {
        setBusy(true);

        const response = await updateActivityAsync(nationId, activityId, data);
        setBusy(false);
        return response;
    };

    const doActivityAssignKPI = async (nationId: number, activityId: number, data: any) => {
        setBusy(true);

        const response = await assignActivityKpiAsync(nationId, activityId, data);
        setBusy(false);
        return response;
    };

    const doActivityRemoveKPI = async (nationId: number, activityId: number, kpiIds: number[]) => {
        setBusy(true);

        const response = await removeActivityKpiAsync(nationId, activityId, { kpi_ids: kpiIds });
        setBusy(false);
        return response;
    };

    const doActivityDisable = async (nationId: number, activityId: number) => {
        setBusy(true);
        const response = await disableActivityAsync(nationId, activityId);
        setBusy(false);
        return response;
    };

    const doActivityEnable = async (nationId: number, activityId: number) => {
        setBusy(true);
        const response = await enableActivityAsync(nationId, activityId);
        setBusy(false);
        return response;
    };

    return { busy, doActivityCreate, doActivityUpdate, doActivityAssignKPI, doActivityRemoveKPI, doActivityDisable, doActivityEnable };
};